<template>
  <b-container fluid class="animated fadeIn">
    <h1>Incluir Série</h1>
    


  </b-container>
</template>

<script>

export default {
  name : 'EditarSerie'
}
</script>

<style>
</style>
